import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/core/utils/cn';
export function Skeleton({ className, ...props }) {
    return _jsx("div", { className: cn('skeleton h-4 w-full rounded-md', className), ...props });
}
